import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import awards from "../awards.json";

function Awards() {
  return (
    <Container className="mt-5 mb-5" id="awards">
      <h1 className="display-1 text-light monospace bold text-center mb-5">
        Awards & Recognition
      </h1>
      <Row className="justify-content-center">
        {awards.awards.map((award, index) => (
          <Col xs={12} md={6} xl={4} className="my-3" key={`award-${index}`}>
            <Card
              style={{ width: "100%", backgroundColor: "#1d1836", height: "100%" }}
              className="text-light text-start p-3"
            >
              <Card.Body className="p-0">
                <Card.Title className="boldest card-title">{award.title}</Card.Title>
                <Card.Subtitle className="text-muted-light mb-2">
                  {award.organization}
                </Card.Subtitle>
                <Card.Text className="monospace text-muted-light mb-3">
                  {award.date}
                </Card.Text>
                <Card.Text>{award.description}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default Awards;
